module.exports = __webpack_public_path__ + "static/img/Downloader.la-65d4f4ea3261f.bc844295.jpg";